export type FileValidationOptions = {
  accept?: string;
  maxFiles?: number;
  maxSizeBytes?: number;
  existingCount?: number;
};

export const formatFileSize = (size: number) => {
  if (!Number.isFinite(size) || size < 0) return "-";
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  if (size < 1024 * 1024 * 1024)
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

export const fileIdentity = (file: File) =>
  `${file.name.toLocaleLowerCase()}-${file.size}-${file.lastModified}`;

const acceptsFile = (file: File, accept?: string) => {
  if (!accept?.trim()) return true;
  return accept.split(",").some((rawRule) => {
    const rule = rawRule.trim().toLocaleLowerCase();
    const type = file.type.toLocaleLowerCase();
    const name = file.name.toLocaleLowerCase();
    if (rule.startsWith(".")) return name.endsWith(rule);
    if (rule.endsWith("/*")) return type.startsWith(rule.slice(0, -1));
    return type === rule;
  });
};

export function validateFiles(
  current: File[],
  incoming: File[],
  options: FileValidationOptions,
) {
  const accepted: File[] = [];
  const errors: string[] = [];
  const identities = new Set(current.map(fileIdentity));
  const maxFiles = options.maxFiles ?? Number.POSITIVE_INFINITY;
  let total = current.length + (options.existingCount ?? 0);

  incoming.forEach((file) => {
    if (identities.has(fileIdentity(file))) {
      errors.push(`"${file.name}" já foi selecionado.`);
      return;
    }
    if (!acceptsFile(file, options.accept)) {
      errors.push(`"${file.name}" possui um formato não permitido.`);
      return;
    }
    if (options.maxSizeBytes && file.size > options.maxSizeBytes) {
      errors.push(
        `"${file.name}" excede o limite de ${formatFileSize(options.maxSizeBytes)}.`,
      );
      return;
    }
    if (total >= maxFiles) {
      errors.push(`"${file.name}" excede o limite de ${maxFiles} arquivo(s).`);
      return;
    }
    identities.add(fileIdentity(file));
    accepted.push(file);
    total += 1;
  });

  return { accepted, errors };
}

